import { Skeleton } from 'antd';
import parse from 'html-react-parser';
import moment from "moment";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function BlogDetailPage() {
	const location = useLocation();
	const { state } = location; // Get the whole state
	const blogData = state?.data; // Access blogData from state

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}, [])

	return (
		<>
		{
			blogData !== null ?
			<section className="section-spacing-x section-spacing-x-mobile py-4">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12">
							<h1 className="main-heading text-center mb-0">{blogData?.fld_title}</h1>
							{/* <p className="text-center mt-2">{moment(blogData?.fld_createdon, "DD/MM/YYYY").format("D-MMM-YYYY")}</p> */}
							<p className="text-center mt-2">
                            <b>
                              {moment(blogData.fld_createdon, "DD/MM/YYYY").format(
                                "DD"
                              )}{" "}
                            </b>
                            <b>
                              {moment(blogData.fld_createdon, "DD/MM/YYYY").format(
                                "MMM"
                              )}{" "}
                            </b>
                            <b>
                              {moment(blogData.fld_createdon, "DD/MM/YYYY").format(
                                "YYYY"
                              )}
                            </b></p>
							<div className='text-center'>
								<img
									src={blogData?.fld_blogimage}
									className="img-fluid mx-auto mb-4"
									alt=""
								/>
							</div>
							<p>
								{parse(blogData?.fld_content)}
							</p>
						</div>
					</div>
				</div>
			</section> :
			<section className="section-spacing-x section-spacing-x-mobile py-4">
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<h1 className="main-heading text-center mb-0"><Skeleton.Input/></h1>
						{/* <p className="text-center mt-2">{moment(blogData?.fld_createdon, "DD/MM/YYYY").format("D-MMM-YYYY")}</p> */}
						<p className="text-center mt-2">
						<Skeleton.Input/></p>
						<div className='text-center'>
							<Skeleton.Image
								className="img-fluid mx-auto mb-4"
								alt=""
							/>
						</div>
						<p>
							<Skeleton.Input/>
						</p>
					</div>
				</div>
			</div>
		</section>
		}
		</>
	);
}
